export const TEXT = {
  BACK: 'Back',
};
